export default "__VITE_ASSET__8d495132__"